import axios from 'axios';

const getAllCustomerPaymentApi = async (token, user_id, filterValues, type) => {
  const url = `/payments?user_id=${user_id}&type=${type ? type : null}&page=${
    filterValues.page
  }&searchText=${filterValues.searchText ? filterValues.searchText : null}`;
  try {
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllCustomerPaymentApi;
